import React from "react";

import Image from "next/image";

import ClockIcon from "public/images/icons/Clock-green.svg";
import ShieldIcon from "public/images/icons/Shield-green.svg";
import NetworkIcon from "public/images/icons/solar-financing-operating-system/Nationwide-network-green.svg";

import HeroSection from "components/hero-section";

const credentials = [
  { icon: ShieldIcon, label: "SOC 2 Type II Certified" },
  { icon: ClockIcon, label: "Go live in weeks, not months" },
  { icon: NetworkIcon, label: "Nationwide Installer Network" },
];

const InfrastructureCredentials = () => (
  <div className="shadow-xl z-20 relative">
    <HeroSection className="sm:py-6 lg:py-6">
      <HeroSection.Content className="text-gray-500 text-sm flex flex-col gap-x-8 gap-y-4 px-4 lg:px-4 sm:items-center sm:flex-row justify-center">
        <p className="text-center font-bold uppercase tracking-wide">Infrastructure Credentials</p>
        <ul className="mx-auto space-y-2 xs:space-y-0 xs:flex gap-x-6 gap-y-2 flex-wrap justify-center sm:justify-start sm:mx-0">
          {credentials.map(item => (
            <li key={item.label} className="flex gap-2 items-center">
              <figure className="h-5 w-5">
                <Image src={item.icon} alt={`${item.label} - Icon`} />
              </figure>
              <p>{item.label}</p>
            </li>
          ))}
        </ul>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default InfrastructureCredentials;
